"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _styledNormalize = require("styled-normalize");

var _mediaQueries = _interopRequireDefault(require("../../mediaQueries"));

var _templateObject, _templateObject2, _templateObject3;

var _default = (0, _styledComponents.createGlobalStyle)(["", " html{background-color:", ";color:", ";font-family:'Source Sans Pro',sans-serif;font-size:", ";font-weight:", ";line-height:", ";text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}*,*:before,*:after{box-sizing:border-box;}h1{line-height:", ";font-weight:", ";font-size:", ";margin:0 0 ", " 0;", "}h2{line-height:", ";font-weight:", ";font-size:", ";margin:", " 0 ", " 0;", "}h3{line-height:", ";font-weight:", ";font-size:", ";margin:", " 0 ", " 0;", "}p{font-size:", ";margin:0 0 ", " 0;}small{font-size:", ";color:", ";}a{text-decoration-skip-ink:auto;color:", ";&:hover,&:active{color:", ";}}a[disabled]{pointer-events:none;}"], _styledNormalize.normalize, function (p) {
  return p.theme.tokens.colorBackground;
}, function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.tokens.baseFontSize;
}, function (p) {
  return p.theme.tokens.fontWeightRegular;
}, function (p) {
  return p.theme.tokens.lineHeightText;
}, function (p) {
  return p.theme.tokens.lineHeightHeading;
}, function (p) {
  return p.theme.tokens.fontWeightBold;
}, function (p) {
  return p.theme.tokens.fontSizeXXLarge;
}, function (p) {
  return p.theme.tokens.spacing05;
}, _mediaQueries["default"].xs(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n      font-size: ", ";\n    "])), function (p) {
  return p.theme.tokens.fontSizeXLarge;
}), function (p) {
  return p.theme.tokens.lineHeightHeading;
}, function (p) {
  return p.theme.tokens.fontWeightBold;
}, function (p) {
  return p.theme.tokens.fontSizeXLarge;
}, function (p) {
  return p.theme.tokens.spacing09;
}, function (p) {
  return p.theme.tokens.spacing04;
}, _mediaQueries["default"].xs(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n      font-size: ", ";\n      margin-top: ", ";\n    "])), function (p) {
  return p.theme.tokens.fontSizeLarge;
}, function (p) {
  return p.theme.tokens.spacing07;
}), function (p) {
  return p.theme.tokens.lineHeightHeading;
}, function (p) {
  return p.theme.tokens.fontWeightBold;
}, function (p) {
  return p.theme.tokens.fontSizeLarge;
}, function (p) {
  return p.theme.tokens.spacing07;
}, function (p) {
  return p.theme.tokens.spacing04;
}, _mediaQueries["default"].xs(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n      font-size: ", ";\n      margin-top: ", ";\n    "])), function (p) {
  return p.theme.tokens.fontSizeMedium;
}, function (p) {
  return p.theme.tokens.spacing05;
}), function (p) {
  return p.theme.tokens.fontSizeMedium;
}, function (p) {
  return p.theme.tokens.spacing05;
}, function (p) {
  return p.theme.tokens.fontSizeSmall;
}, function (p) {
  return p.theme.colorTextLabel;
}, function (p) {
  return p.theme.colorTextLink;
}, function (p) {
  return p.theme.colorTextLinkHover;
});

exports["default"] = _default;